import { render, staticRenderFns } from "./MedicatinVaccines.vue?vue&type=template&id=cbdd2236&scoped=true"
import script from "./MedicatinVaccines.vue?vue&type=script&lang=js"
export * from "./MedicatinVaccines.vue?vue&type=script&lang=js"
import style0 from "./MedicatinVaccines.vue?vue&type=style&index=0&id=cbdd2236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbdd2236",
  null
  
)

export default component.exports